// extracted by mini-css-extract-plugin
module.exports = {"root":"Node_root__1Ol_I","row":"Node_row__1rlQ2","label":"Node_label__1UXIZ","footer":"Node_footer__1F9CK"};